// import React from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Avatar,
//   Divider,
// } from "@mui/material";

// const OTPVerification = () => {
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         p: 2,
//       }}
//     >
//       <Box
//         sx={{
//           backgroundColor: "#ffffff",
//           borderRadius: "20px",
//           boxShadow: 6,
//           p: 4,
//           width: "100%",
//           maxWidth: 480,
//         }}
//       >
//         {/* Logo and Header */}
//         <Box textAlign="center" mb={4}>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 700,
//               background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//               backgroundClip: "text",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               mb: 1,
//               fontFamily: "Outfit",
//             }}
//           >
//             OTP Verification
//           </Typography>
//           <Typography
//             variant="body1"
//             color="text.secondary"
//             mt={2}
//             sx={{ fontFamily: "Outfit" }}
//           >
//             We've sent a 4-digit verification code to
//           </Typography>
//         </Box>

//         {/* OTP Input Fields */}
//         <Box mb={3}>
//           <Typography
//             variant="h6"
//             fontWeight="bold"
//             textAlign="center"
//             mb={2}
//             color="text.secondary"
//             sx={{ fontFamily: "Outfit" }}
//           >
//             Enter Verification Code
//           </Typography>

//           <Box display="flex" gap={1} justifyContent="center">
//             {Array(4)
//               .fill("")
//               .map((_, index) => (
//                 <TextField
//                   key={index}
//                   variant="outlined"
//                   inputProps={{
//                     maxLength: 1,
//                     style: {
//                       textAlign: "center",
//                       fontSize: "1.5rem",
//                       fontWeight: "bold",
//                       width: "56px",
//                       height: "56px",
//                     },
//                   }}
//                 />
//               ))}
//           </Box>
//         </Box>

//         {/* Verify Button */}
//         <Button
//           fullWidth
//           variant="contained"
//           sx={{
//             textTransform: "none",
//             borderRadius: "12px",
//             py: 1.5,
//             fontSize: "1rem",
//             fontWeight: 600,
//             fontFamily: "Outfit",
//             mb: 2,
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           }}
//         >
//           Verify OTP
//         </Button>

//         {/* Back to Login */}
//         <Box
//           sx={{
//             borderRadius: "12px",
//             p: "2px", // this is the thickness of the border
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             mb: 2,
//           }}
//         >
//           <Button
//             variant="text"
//             fullWidth
//             sx={{
//               textTransform: "none",
//               borderRadius: "10px", // slightly smaller to fit inside wrapper
//               py: 1.5,
//               fontSize: "1rem",
//               fontWeight: 600,
//               fontFamily: "Outfit",
//               backgroundColor: "#fff", // inner background
//               color: "#764ba2",
//             }}
//           >
//             Back to Login
//           </Button>
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* Footer */}
//         <Typography
//           variant="caption"
//           textAlign="center"
//           display="block"
//           sx={{ fontFamily: "Outfit", color: "text.secondary" }}
//         >
//           © 2025 Getgeek. All rights reserved.
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default OTPVerification;
import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  LinearProgress,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateUserManually } from "../redux/slices/authSlice";
import GetGeekLogo from "../../src/assets/images/GetGeekLogo.png";

const OTPVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const inputRefs = useRef([]);
  const errorTimeoutRef = useRef(null);
  const successTimeoutRef = useRef(null);

  // OTP status states
  const [otpStatus, setOtpStatus] = useState({
    hasActiveOTP: false,
    isExpired: false,
    remainingTimeSeconds: 0,
    attemptsUsed: 0,
    maxAttempts: 3,
  });
  const [resendLoading, setResendLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const statusCheckInterval = useRef(null);
  const countdownInterval = useRef(null);

  // Get email from navigation state
  const email = location.state?.email || "";

  // Get base URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

  // Check OTP Status function
  const checkOTPStatus = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/check-otp-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setOtpStatus(data);

        // If OTP is expired, show message
        if (data.isExpired) {
          setError("OTP has expired. Please login again.");
        }
      }
    } catch (error) {
      console.error("Error checking OTP status:", error);
    }
  };

  // Start status checking interval
  const startStatusCheck = () => {
    if (statusCheckInterval.current) {
      clearInterval(statusCheckInterval.current);
    }

    statusCheckInterval.current = setInterval(() => {
      checkOTPStatus();
    }, 10000); // Check every 10 seconds
  };

  // Start countdown timer
  const startCountdown = (seconds) => {
    if (countdownInterval.current) {
      clearInterval(countdownInterval.current);
    }

    let timeLeft = seconds;
    setResendCooldown(timeLeft);

    countdownInterval.current = setInterval(() => {
      timeLeft -= 1;
      setResendCooldown(timeLeft);

      if (timeLeft <= 0) {
        clearInterval(countdownInterval.current);
        countdownInterval.current = null;
      }
    }, 1000);
  };

  useEffect(() => {
    // If no email is provided, redirect back to login
    if (!email) {
      navigate("/");
      return;
    }

    // Check if user is already authenticated (has token in localStorage)
    const existingToken = localStorage.getItem("@getGeek/token");
    if (existingToken) {
      // If token exists, try to restore user state and redirect to dashboard
      dispatch(updateUserManually({
        id: email,
        email: email,
        isAuthenticated: true
      }));
      navigate("/Dashboard");
      return;
    }

    // Focus on first input
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }

    // Start checking OTP status
    checkOTPStatus();
    startStatusCheck();

    // Cleanup function to clear timeouts and intervals
    return () => {
      if (errorTimeoutRef.current) {
        clearTimeout(errorTimeoutRef.current);
      }
      if (successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current);
      }
      if (statusCheckInterval.current) {
        clearInterval(statusCheckInterval.current);
      }
      if (countdownInterval.current) {
        clearInterval(countdownInterval.current);
      }
    };
  }, [email, navigate]);

  // Auto-verify OTP when all 4 digits are entered
  useEffect(() => {
    const otpString = otp.join("");
    if (otpString.length === 4 && !loading) {
      // Add a small delay to ensure the last digit is properly set
      setTimeout(() => {
        handleVerifyOtp();
      }, 300);
    }
  }, [otp]);

  const handleVerifyOtp = async () => {
    const otpString = otp.join("");

    if (otpString.length !== 4) {
      setError("Please enter complete 4-digit OTP");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    // Clear any existing timeouts
    if (errorTimeoutRef.current) {
      clearTimeout(errorTimeoutRef.current);
      errorTimeoutRef.current = null;
    }
    if (successTimeoutRef.current) {
      clearTimeout(successTimeoutRef.current);
      successTimeoutRef.current = null;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/super-admin/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          otp: otpString,
        }),
      });

      const data = await response.json();

      if (data.success) {
        // Clear intervals on success
        if (statusCheckInterval.current) {
          clearInterval(statusCheckInterval.current);
        }
        if (countdownInterval.current) {
          clearInterval(countdownInterval.current);
        }

        // Set user in Redux store after successful OTP verification
        if (data.user) {
          // Ensure the user object has authentication flag
          const userData = {
            ...data.user,
            isAuthenticated: true
          };
          console.log("Setting user from API response:", userData);
          dispatch(updateUserManually(userData));
        } else {
          // If no user data in response, create a basic user object
          const userData = {
            id: email, // Use email as ID if no user ID provided
            email: email,
            isAuthenticated: true
          };
          console.log("Setting basic user data:", userData);
          dispatch(updateUserManually(userData));
        }

        // Store token in localStorage if provided
        if (data.token) {
          console.log("Storing token in localStorage");
          localStorage.setItem("@getGeek/token", data.token);
        }

        // Navigate to dashboard immediately without any success message or delay
        console.log("Navigating to Dashboard after successful OTP verification");
        navigate("/Dashboard");
      } else {
        setError(data.message || "OTP verification failed");

        // Check if it's an expiration error
        if (data.expired) {
          // Clear intervals if expired
          if (statusCheckInterval.current) {
            clearInterval(statusCheckInterval.current);
          }
        } else {
          // Refresh status after failed attempt
          setTimeout(() => {
            checkOTPStatus();
          }, 1000);
        }

        // Clear OTP fields on error and focus on first input
        setOtp(["", "", "", ""]);
        setTimeout(() => {
          inputRefs.current[0]?.focus();
        }, 100);
        // Auto-clear error message after 5 seconds
        errorTimeoutRef.current = setTimeout(() => {
          setError("");
          errorTimeoutRef.current = null;
        }, 5000);
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      setError("Network error. Please try again.");
      // Clear OTP fields on network error and focus on first input
      setOtp(["", "", "", ""]);
      setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 100);
      // Auto-clear error message after 5 seconds
      errorTimeoutRef.current = setTimeout(() => {
        setError("");
        errorTimeoutRef.current = null;
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (index, value) => {
    // Only allow digits and limit to 1 character
    if (!/^\d*$/.test(value) || value.length > 1) return;

    // Clear error and success messages immediately when user types anything
    setError("");
    setSuccess("");

    // Clear any pending timeouts
    if (errorTimeoutRef.current) {
      clearTimeout(errorTimeoutRef.current);
      errorTimeoutRef.current = null;
    }
    if (successTimeoutRef.current) {
      clearTimeout(successTimeoutRef.current);
      successTimeoutRef.current = null;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input if current is filled
    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Clear messages on any key interaction
    if (error || success) {
      setError("");
      setSuccess("");

      // Clear any pending timeouts
      if (errorTimeoutRef.current) {
        clearTimeout(errorTimeoutRef.current);
        errorTimeoutRef.current = null;
      }
      if (successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current);
        successTimeoutRef.current = null;
      }
    }

    // Move to previous input on backspace if current is empty
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");

    // Check if pasted data is 4 digits
    if (/^\d{4}$/.test(pastedData)) {
      const newOtp = pastedData.split("");
      setOtp(newOtp);

      // Focus on last input
      inputRefs.current[3]?.focus();
      // Auto-verification will be triggered by the useEffect when otp state changes
    }
  };

  const handleBackToLogin = () => {
    // Clear intervals before navigating
    if (statusCheckInterval.current) {
      clearInterval(statusCheckInterval.current);
    }
    if (countdownInterval.current) {
      clearInterval(countdownInterval.current);
    }
    navigate("/");
  };

  // Enhanced Resend OTP function using new API
  const handleResendOtp = async () => {
    setResendLoading(true);
    setError("");
    setSuccess("");

    // Clear any existing timeouts
    if (errorTimeoutRef.current) {
      clearTimeout(errorTimeoutRef.current);
      errorTimeoutRef.current = null;
    }
    if (successTimeoutRef.current) {
      clearTimeout(successTimeoutRef.current);
      successTimeoutRef.current = null;
    }

    try {
      // Use dedicated resend-otp API
      const response = await fetch(`${API_BASE_URL}/super-admin/resend-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess("New OTP sent successfully!");
        setOtp(["", "", "", ""]);

        // Start 30-second cooldown for resend button
        startCountdown(30);

        // Refresh OTP status
        setTimeout(() => {
          checkOTPStatus();
        }, 1000);

        setTimeout(() => {
          inputRefs.current[0]?.focus();
        }, 100);
        // Auto-clear success message after 3 seconds
        successTimeoutRef.current = setTimeout(() => {
          setSuccess("");
          successTimeoutRef.current = null;
        }, 3000);
      } else {
        setError(data.message || "Failed to resend OTP");

        // Handle rate limiting message
        if (data.message && data.message.includes("wait")) {
          const waitTime = data.message.match(/\d+/);
          if (waitTime) {
            startCountdown(parseInt(waitTime[0]));
          }
        }

        // Auto-clear error message after 5 seconds
        errorTimeoutRef.current = setTimeout(() => {
          setError("");
          errorTimeoutRef.current = null;
        }, 5000);
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      setError("Network error. Please try again.");
      // Auto-clear error message after 5 seconds
      errorTimeoutRef.current = setTimeout(() => {
        setError("");
        errorTimeoutRef.current = null;
      }, 5000);
    } finally {
      setResendLoading(false);
    }
  };

  // Format time for display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  // Get progress percentage for countdown
  const getProgressPercentage = () => {
    if (!otpStatus.remainingTimeSeconds) return 0;
    const totalTime = 10 * 60; // 10 minutes in seconds
    return (otpStatus.remainingTimeSeconds / totalTime) * 100;
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          p: 4,
          width: "100%",
          maxWidth: 480,
        }}
      >
        {/* Logo and Header */}
        <Box textAlign="center" mb={4}>
          <Box
            component="img"
            src={GetGeekLogo}
            alt="GetGeek Logo"
            sx={{
              width: 180,
              height: 60,
              margin: "0 auto",
              mb: 2,
              background: "white",
            }}
          />
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 1,
              fontFamily: "Outfit",
            }}
          >
            OTP Verification
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            mt={2}
            sx={{ fontFamily: "Outfit" }}
          >
            We've sent a 4-digit code to
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Outfit",
              fontWeight: 600,
              color: "#667eea",
            }}
          >
            {email}
          </Typography>
        </Box>

        {/* Attempts Counter */}
        {otpStatus.attemptsUsed > 0 && (
          <Box mb={2}>
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
              sx={{ fontFamily: "Outfit" }}
            >
              Attempts used: {otpStatus.attemptsUsed} / {otpStatus.maxAttempts}
            </Typography>
          </Box>
        )}

        {/* Error Alert */}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 3, borderRadius: 2, fontFamily: "Outfit" }}
          >
            {error}
          </Alert>
        )}

        {/* Success Alert */}
        {success && (
          <Alert
            severity="success"
            sx={{ mb: 3, borderRadius: 2, fontFamily: "Outfit" }}
          >
            {success}
          </Alert>
        )}

        {/* OTP Input Fields */}
        <Box mb={3}>
          <Typography
            variant="h6"
            fontWeight="bold"
            textAlign="center"
            mb={3}
            color="text.secondary"
            sx={{ fontFamily: "Outfit" }}
          >
            Enter Verification Code
          </Typography>

          <Box display="flex" gap={2} justifyContent="center" mb={2}>
            {otp.map((digit, index) => (
              <TextField
                key={index}
                inputRef={(el) => (inputRefs.current[index] = el)}
                variant="outlined"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={index === 0 ? handlePaste : undefined}
                disabled={loading || otpStatus.isExpired}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: "center",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    fontFamily: "Outfit",
                    padding: "16px 0",
                  },
                }}
                sx={{
                  width: "60px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#667eea",
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#667eea",
                        borderWidth: "2px",
                        boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#e0e0e0",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Manual Verify Button (now optional/backup) */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleVerifyOtp}
          disabled={
            loading || otp.some((digit) => digit === "") || otpStatus.isExpired
          }
          sx={{
            textTransform: "none",
            borderRadius: "12px",
            py: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Outfit",
            mb: 2,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
            },
            "&:disabled": {
              background: "#ccc",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Verify OTP"
          )}
        </Button>

        {/* Enhanced Resend OTP Button */}
        <Box
          sx={{
            borderRadius: "12px",
            p: "2px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            mb: "4%",
          }}
        >
          <Button
            fullWidth
            onClick={handleResendOtp}
            disabled={
              loading ||
              resendLoading ||
              resendCooldown > 0 ||
              otpStatus.isExpired
            }
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              py: 1.5,
              fontSize: "1rem",
              fontWeight: 600,
              fontFamily: "Outfit",
              backgroundColor: "#fff",
              color: "#764ba2",
              width: "100%",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
              "&:disabled": {
                color: "#ccc",
              },
            }}
          >
            {resendLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : resendCooldown > 0 ? (
              `Resend OTP (${resendCooldown}s)`
            ) : (
              "Resend OTP"
            )}
          </Button>
        </Box>

        {/* Back to Login */}
        <Box
          sx={{
            borderRadius: "12px",
            p: "2px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            mb: 2,
          }}
        >
          <Button
            variant="text"
            fullWidth
            onClick={handleBackToLogin}
            disabled={loading}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              py: 1.5,
              fontSize: "1rem",
              fontWeight: 600,
              fontFamily: "Outfit",
              backgroundColor: "#fff",
              color: "#764ba2",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
              "&:disabled": {
                color: "#ccc",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Back to Login
          </Button>
        </Box>

        {/* Footer */}
        <Typography
          variant="caption"
          textAlign="center"
          display="block"
          sx={{ fontFamily: "Outfit", color: "text.secondary" }}
        >
          © 2025 Getgeek. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default OTPVerification;
